export default __webpack_public_path__ + "static/logo-0ee981901b358acbcb661fb78560a659.png";